import Tooltip from "./Tooltip";

export const PENDING_ZONE_MESSAGE =
  "This unit will be added to this zone upon connection";

const InfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className="size-full"
    aria-hidden="true"
  >
    <circle cx="8" cy="8" r="6.25" stroke="currentColor" strokeWidth="1.5" />
    <path d="M8 7.25V11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="8" cy="5" r="0.85" fill="currentColor" />
  </svg>
);

const PendingZoneBadge = ({
  className = "size-4",
  "data-testid": dataTestId = "pending-zone-badge",
}) => (
  <Tooltip
    content={PENDING_ZONE_MESSAGE}
    className={`pendingZoneBadgeHolder inline-flex shrink-0 text-theme ${className}`}
    bubbleClassName="whitespace-normal w-48 text-center"
    distanceClassName={{ up: "bottom-6", down: "top-6" }}
    role="img"
    aria-label={PENDING_ZONE_MESSAGE}
    data-testid={dataTestId}
  >
    <InfoIcon />
  </Tooltip>
);

export default PendingZoneBadge;
